module.exports = __webpack_public_path__ + "static/media/filled_bar_M2_tall.da613bc9.svg";